import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { KeyValueType } from '@models/common';
import { FieldTypeEnum } from '@models/module/fields/enums';
import { FilterLogic, FilterOperator, FilterOperatorKey } from '@models/module/grid';

export type DataListCommandFilterType = {
  name: string;
  fieldId: number | string;
  typeId?: number;
  type?: DataListFilterType;
  operators?: FilterOperatorKey[];
  selectedOperator?: FilterOperatorKey;
  values?: KeyValueType<any>[];
  selectedValue?: string;
  searchableValue?: boolean;
  multipleSelection?: boolean;
  getValues?: Observable<KeyValueType[]>;
};

export type DataListFilterType = 'text' | 'number' | 'date' | 'bool';

export type DataListFilter = {
  field: string;
  //   remove optional
  fieldTypeId?: FieldTypeEnum;
  operator: FilterOperator;
  dataSource?: KeyValueType[];
  value: string | number | boolean | string[] | number[];
};

export type FiltersToApply = {
  criteria?: string;
  filters?: LocalFilterModel;
  isQuickFilter?: boolean;
  isGlobalSearch?: boolean;
};

export interface LocalFilterModel {
  logic?: FilterLogic;
  filterList: DataListFilter[];
}

export interface DataListFilterFormGroup {
  operator: FormControl<FilterOperatorKey | null>;
  value: FormControl<string>;
}

export interface FiltersFormGroup {
  [key: string]: FormGroup<DataListFilterFormGroup>;
}
